export const DEFAULT_CENTER = [9.7679, 4.0511]; // Douala, Cameroon

export async function geocode(q, token, proximity) {
  const prox = proximity ? `&proximity=${proximity[0]},${proximity[1]}` : "";
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(q)}.json?access_token=${token}&limit=5&language=en${prox}`;
  const r = await fetch(url);
  const j = await r.json();
  return (j.features || []).map((f) => ({ address: f.place_name, lng: f.center[0], lat: f.center[1] }));
}

export async function reverseGeocode(lng, lat, token) {
  try {
    const r = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${token}&limit=1&language=en`);
    const j = await r.json();
    return j.features?.[0]?.place_name || "";
  } catch { return ""; }
}

export async function getRoute(a, b, token) {
  const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${a.lng},${a.lat};${b.lng},${b.lat}?geometries=geojson&overview=full&access_token=${token}`;
  const r = await fetch(url);
  const j = await r.json();
  return j.routes?.[0]?.geometry || null;
}
